import { render } from "./PasswordGet.vue?vue&type=template&id=019071ac&scoped=true"
import script from "./PasswordGet.vue?vue&type=script&lang=js"
export * from "./PasswordGet.vue?vue&type=script&lang=js"

import "./PasswordGet.vue?vue&type=style&index=0&id=019071ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019071ac"]])

export default __exports__